import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M21.2291 33.1042L35.1822 19.1511L32.4114 16.3802L21.2291 27.5625L15.5885 21.9219L12.8176 24.6928L21.2291 33.1042ZM23.9999 43.7917C21.2621 43.7917 18.6892 43.2722 16.2812 42.2331C13.8732 41.1941 11.7786 39.7839 9.99731 38.0026C8.21606 36.2214 6.80591 34.1268 5.76685 31.7188C4.72778 29.3108 4.20825 26.7379 4.20825 24C4.20825 21.2622 4.72778 18.6893 5.76685 16.2813C6.80591 13.8733 8.21606 11.7787 9.99731 9.99744C11.7786 8.21619 13.8732 6.80603 16.2812 5.76697C18.6892 4.72791 21.2621 4.20837 23.9999 4.20837C26.7378 4.20837 29.3107 4.72791 31.7187 5.76697C34.1267 6.80603 36.2213 8.21619 38.0025 9.99744C39.7838 11.7787 41.1939 13.8733 42.233 16.2813C43.2721 18.6893 43.7916 21.2622 43.7916 24C43.7916 26.7379 43.2721 29.3108 42.233 31.7188C41.1939 34.1268 39.7838 36.2214 38.0025 38.0026C36.2213 39.7839 34.1267 41.1941 31.7187 42.2331C29.3107 43.2722 26.7378 43.7917 23.9999 43.7917Z",
		fill: "url(#paint0_linear_3487_76182)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_3487_76182",
		x1: 3.99997,
		y1: 44.3126,
		x2: 50.6828,
		y2: 13.9688,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedCheck;
